import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, map } from 'rxjs';
import { AssessmentReportsService, RdSAPAssessmentReportMimeTypes, ReportStatus } from 'src/rdsap-api';
import { RdSAPAssessmentReportUIDTOV0 } from 'src/rdsap-api/model/rdSAPAssessmentReportUIDTOV0';
import { environment } from '../../../environments/environment';

export interface RdSAPAssessmentReport extends RdSAPAssessmentReportUIDTOV0{
  generic: any;
  reportStatus: ReportStatus;
}

// Define the custom data service
// this service overrides the @ngrx/data default data service and fetches data with custom services
@Injectable()
export class AssetRdSAPDetailsService extends DefaultDataService<RdSAPAssessmentReport> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, private assessmentReportService: AssessmentReportsService) {
    super('RdSAPDetails', http, httpUrlGenerator);
  }

  getWithQuery(params: { quid: string, reportReferenceNumber: string}): Observable<RdSAPAssessmentReport[]> {
    const { quid, reportReferenceNumber } = params;

    return this.assessmentReportService.newReadAssessment(reportReferenceNumber, environment.accept as RdSAPAssessmentReportMimeTypes, 'response').pipe(
      map(data => {
        const header = data.headers.get('X-Lodgement-Status') as ReportStatus;
        const response = data.body as unknown as RdSAPAssessmentReport;
        response.reportStatus = header;
        return [response];
      }) // Wrap data in an array as NgRx Data expects an array
    );
  }
}
